import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { EnableWorksheetDocument, GqlError } from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

import { Worksheet, WorksheetDetail } from '../../types'
import { parseGqlWorksheetResponse } from '../parser'

const enableWorksheet = async ({
  worksheetUid,
  reason,
}: {
  worksheetUid: Worksheet['uid']
  reason: string
}): Promise<WorksheetDetail> => {
  try {
    const res = await graphqlRequest(EnableWorksheetDocument, {
      input: {
        worksheetUid,
        reason,
      },
    })
    return parseGqlWorksheetResponse(res.enableWorksheet.worksheet)
  } catch (error) {
    throw error
  }
}

export const useEnableWorksheet = (
  option?: UseMutationOption<WorksheetDetail, GqlError>,
) => {
  return useMutation(
    ({
      worksheetUid,
      reason,
    }: {
      worksheetUid: Worksheet['uid']
      reason: string
    }) => enableWorksheet({ worksheetUid, reason }),
    option,
  )
}
